import { Building16Regular } from "@fluentui/react-icons";
import { useTranslation } from "react-i18next";

function Header() {
  const { t } = useTranslation();
  return (
    <div
        className=" flex flex-col space-y-2 px-6 pb-6 pt-8 border-b-[2px] border-b-cool-gray-200">
        <p
          className=" text-2xl font-bold text-cool-gray-700">
          {t("assessment-check-result")}
        </p>
        <p
          className=" text-sm font-normal text-cool-gray-700">
          {t("for-reference-during-assessment-report-creation")}
        </p>
        <div
          className=" flex flex-row space-x-[6px] items-center">
          <Building16Regular />
          <p
            className=" text-sm font-normal text-cool-gray-600">
            {t("xx-Co-Ltd.")}
          </p>
        </div>
      </div>
  )
}

export default Header